/*
 * @Author: luting
 * @Date: 2022-04-12 10:40:09
 * @lastEditors: luting
 * @LastEditTime: 2022-04-19 20:02:39
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  installCancel: "已取消supOS安装",
  cancelSure: '确认',
});
